import { useQuery } from 'react-query';
import eventLogService, { EventLogUser } from '../services/eventLog.service';

const useEventLogUsers = (clinicId: number, startDate?: string, endDate?: string) => {
  const { status, data, error, isFetching, refetch } = useQuery<{ data: EventLogUser[] }>(
    ['eventLogUsers', clinicId, startDate, endDate],
    () => eventLogService.listUsers(clinicId, { startDate, endDate }),
    {
      refetchOnWindowFocus: false,
      enabled: !!clinicId,
    }
  );

  return {
    status,
    data: data?.data || [],
    error,
    isFetching,
    refetch,
  };
};

export default useEventLogUsers;
